import { createRoot } from 'react-dom/client';
import { lazy, Suspense } from 'react';
import './index.css';
import App from './App';
import AppProviders from './context';
import { BrowserRouter } from 'react-router-dom';
const root = createRoot(document.getElementById('root'));

// Development-only design-system gallery at /start/_showcase (no auth, no session). The
// NODE_ENV check is a build-time constant, so the gallery is not part of production bundles.
const isShowcase = process.env.NODE_ENV === 'development' && window.location.pathname.startsWith(`${process.env.PUBLIC_URL}/_showcase`);

if (isShowcase) {
  const Showcase = lazy(() => import('./dev/Showcase'));
  root.render(
    <BrowserRouter>
      <Suspense fallback={null}>
        <Showcase />
      </Suspense>
    </BrowserRouter>,
  );
} else {
  root.render(
    <BrowserRouter>
      <AppProviders>
        <App />
      </AppProviders>
    </BrowserRouter>,
  );
}
